export default "__VITE_ASSET__CJqRtMmL__"